import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { RequistionCartState } from "@tKgpco/Handlers/RequistionCart/RequistionCartState";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<RequistionCartState, boolean>;

export const PopulateApiParameter: HandlerType = props => {
    props.dispatch({
        type: "Custom/RequistionCart/SetShowDisclaimerForRequistionCart",
        param: props.parameter.showDisclaimerForRequistionCart,
    });
};

export const chain = [PopulateApiParameter];

export const setShowRequisitionCartDisclaimer = createHandlerChainRunner(chain, "setShowRequisitionCartDisclaimer");
export default setShowRequisitionCartDisclaimer;
